import React, { useEffect, useState } from 'react';
import {
    Button,
    DialogActions,
    DialogContent,
    Stack,
    TextField,
} from '@mui/material';
import DialogHeader from '../../../components/Dialog/DialogHeader';
import UserDialog from '../../../components/Dialog/UserDialog';
import { EquipmentCategory } from '../../../model/Dto/Dict/EquipmentCategory';

interface EquipmentCategoryDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (data: { name: string; description: string; sortNumber: number }) => Promise<boolean>;
    initialData?: EquipmentCategory | null;
    title: string;
}

export default function EquipmentCategoryDialog({
                                                    open,
                                                    onClose,
                                                    onSave,
                                                    initialData,
                                                    title,
                                                }: EquipmentCategoryDialogProps) {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [sortNumber, setSortNumber] = useState('0');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialData) {
            setName(initialData.name);
            setDescription(initialData.description);
            setSortNumber(String(initialData.sortNumber));
        } else {
            setName('');
            setDescription('');
            setSortNumber('0');
        }
    }, [initialData, open]);

    const handleSave = async () => {
        setLoading(true);
        const success = await onSave({
            name: name.trim(),
            description: description.trim(),
            sortNumber: Number(sortNumber) || 0,
        });
        setLoading(false);
        if (success) onClose();
    };

    return (
        <UserDialog handleClose={onClose} open={open} maxWidth="sm">
            <DialogHeader loading={loading} title={title} />
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 2 }}>
                    <TextField
                        autoFocus
                        label="Название"
                        fullWidth
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        disabled={loading}
                    />
                    <TextField
                        label="Описание"
                        fullWidth
                        multiline
                        rows={3}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        disabled={loading}
                    />
                    <TextField
                        label="Порядковый номер"
                        fullWidth
                        inputProps={{ inputMode: 'numeric' }}
                        value={sortNumber}
                        onChange={(e) => setSortNumber(e.target.value)}
                        disabled={loading}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>Отмена</Button>
                <Button onClick={handleSave} variant="contained" disabled={loading}>
                    {loading ? "Сохранение..." : "Сохранить"}
                </Button>
            </DialogActions>
        </UserDialog>
    );
}